const base = {
  url: process.env.VUE_APP_BASE_URL
}

export default base
